'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var red = {};

exports.__exports = red;
